import gql from "graphql-tag";

const gqlQuery = gql`
  query currentUser {
    currentUser {
      id
      partnerId
      ownedByPartnerId
      username
      name
      email
      telephone
      customerIds
      serviceContractsFilter
      roles {
        id
        name
      }
    }
  }
`;

export default () => ({
  query: gqlQuery,
});
